<template lang="pug">
div
  .qcw-comment-fb-ads
    .thumbnail
      svg(width='32' height='32' viewbox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg')
        g(clip-path='url(#clip0_10654_18934)')
          rect(width='32' height='32' fill='none')
          path(d='M28 9C26.4092 8.99835 24.884 8.36567 23.7592 7.24081C22.6343 6.11595 22.0017 4.59079 22 3C22 2.73478 21.8946 2.48043 21.7071 2.29289C21.5196 2.10536 21.2652 2 21 2H16C15.7348 2 15.4804 2.10536 15.2929 2.29289C15.1054 2.48043 15 2.73478 15 3V19.5C14.9998 19.9474 14.8796 20.3865 14.6518 20.7715C14.4241 21.1566 14.0972 21.4735 13.7053 21.6891C13.3133 21.9048 12.8707 22.0114 12.4236 21.9977C11.9764 21.984 11.5411 21.8506 11.1631 21.6114C10.7851 21.3722 10.4782 21.0359 10.2744 20.6376C10.0707 20.2394 9.97747 19.7938 10.0046 19.3472C10.0317 18.9007 10.1782 18.4696 10.4287 18.099C10.6792 17.7283 11.0245 17.4317 11.4288 17.24C11.5997 17.1589 11.7442 17.0309 11.8453 16.8709C11.9464 16.7109 12.0001 16.5255 12 16.3363V11C12.0001 10.8538 11.9681 10.7094 11.9063 10.5769C11.8445 10.4445 11.7544 10.3271 11.6424 10.2332C11.5304 10.1393 11.3992 10.0711 11.2579 10.0334C11.1167 9.9957 10.9689 9.98942 10.825 10.015C6.36375 10.81 3 14.8875 3 19.5C3 22.0196 4.00089 24.4359 5.78249 26.2175C7.56408 27.9991 9.98044 29 12.5 29C15.0196 29 17.4359 27.9991 19.2175 26.2175C20.9991 24.4359 22 22.0196 22 19.5V14.5363C23.8521 15.5026 25.911 16.0049 28 16C28.2652 16 28.5196 15.8946 28.7071 15.7071C28.8946 15.5196 29 15.2652 29 15V10C29 9.73478 28.8946 9.48043 28.7071 9.29289C28.5196 9.10536 28.2652 9 28 9ZM27 13.955C25.0458 13.7818 23.1746 13.0843 21.5837 11.9362C21.4342 11.8287 21.2579 11.7646 21.0743 11.7509C20.8906 11.7373 20.7068 11.7746 20.543 11.8587C20.3792 11.9429 20.2418 12.0706 20.146 12.2279C20.0502 12.3852 19.9997 12.5658 20 12.75V19.5C20 21.4891 19.2098 23.3968 17.8033 24.8033C16.3968 26.2098 14.4891 27 12.5 27C10.5109 27 8.60322 26.2098 7.1967 24.8033C5.79018 23.3968 5 21.4891 5 19.5C5 16.2625 7.08 13.3588 10 12.3V15.7587C9.35356 16.1907 8.83005 16.7827 8.4805 17.4771C8.13094 18.1716 7.96727 18.9447 8.00542 19.7213C8.04358 20.4978 8.28226 21.2512 8.69821 21.908C9.11417 22.5648 9.69319 23.1027 10.3789 23.4691C11.0645 23.8356 11.8334 24.0182 12.6107 23.999C13.3879 23.9799 14.1469 23.7598 14.8137 23.36C15.4805 22.9603 16.0324 22.3946 16.4156 21.7181C16.7987 21.0417 17.0001 20.2775 17 19.5V4H20.0625C20.2874 5.76135 21.0906 7.39822 22.3462 8.65379C23.6018 9.90937 25.2386 10.7126 27 10.9375V13.955Z' fill='#979797')
        defs
          clippath#clip0_10654_18934
            rect(width='32' height='32' fill='none')

    a.thumbnail-text(
      rel="noopener noreferrer" 
      target="_blank" 
      :href="comment.extras.referral.ad.embed_url"
      ) 
      | {{ comment.extras.referral.ad.ad_name }}
  div Customer interest in your {{ type }}
  </template>

<script>
export default {
  name: "CommentTiktokAds",
  props: ["comment"],
  computed: {
    type() {
      return this.comment.extras.referral.source
        ? this.comment.extras.referral.source
        : "post";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/CommentTiktokAds.vue